/* src/app/components/shared/email-verify-dialog/email-verify-dialog.component.scss */
#emailPanel .txt-center {
  text-align: center;
}
#emailPanel .emailInputButton {
  background-color: var(--theme-deafult-secondary);
  width: 85px;
  padding: 7px;
  border-radius: 15px;
  text-align: center;
  margin-left: 120px;
  margin-top: 20px;
  color: white;
}
/*# sourceMappingURL=email-verify-dialog.component.css.map */
